import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import { getFormattedNumber } from "utility/helpers";
import PropTypes from "prop-types";
import { AddButton } from "assets/js/Styles";
import styled from "styled-components";
import FormGenerator from "../form-generator/input";

const StyledSaveButton = styled(AddButton)`
  background: ${({ theme }) => theme.colors.buttonFormBlue};
  width: 100px;
  border: none;
  height: 45px;
`;

const StyledNumericFormat = styled(FormGenerator)`
  height: 45px;
  margin-bottom: 1.5rem;
`;

const ButtonActionSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ModalBodyContainer = styled.div`
  margin-right: 0.5rem;
  margin-left: 0.5rem;
`;

const BudgetComponent = ({
  value,
  handleOnChange,
  isOpen,
  handleToggle,
  newValue,
  totalAmountSpent,
}) => {
  const [budget, setBudget] = useState();

  const handleSaveClicked = () => {
    if (budget < totalAmountSpent) {
      setBudget(value);

      Swal.fire({
        title: "Error",
        text: `New budget must be higher than ${getFormattedNumber(
          totalAmountSpent
        )}`,
        icon: "error",
        confirmButtonText: "OK",
      });

      return;
    }

    if (budget > totalAmountSpent) {
      handleOnChange(budget);
      handleToggle();
    }
  };

  const handleToggleClicked = () => {
    setBudget(value);
    handleToggle();
  };

  useEffect(() => {
    if (value !== budget) setBudget(value);
  }, [value]);

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleToggleClicked}
      centered
    >
      <ModalHeader toggle={handleToggleClicked}>{"Total Budget"}</ModalHeader>
      <ModalBody>
        <ModalBodyContainer>
          <StyledNumericFormat
            type="number"
            decimalSeparator="."
            thousandSeparator=","
            value={newValue || budget}
            onValueChange={(newBudget) => {
              const { floatValue } = newBudget;
              setBudget(floatValue);
            }}
          />
          <ButtonActionSection>
            <StyledSaveButton
              color="primary"
              onClick={() => handleSaveClicked()}
            >
              {"Save"}
            </StyledSaveButton>
          </ButtonActionSection>
        </ModalBodyContainer>
      </ModalBody>
    </Modal>
  );
};

BudgetComponent.prototype = {
  value: PropTypes.string,
  handleOnChange: PropTypes.func,
  isOpen: PropTypes.bool,
  handleToggle: PropTypes.func,
  newValue: PropTypes.string,
  totalAmountSpent: PropTypes.string,
};

export default BudgetComponent;
